let pieces = [];
let queue = [];
let listeners = {};
let timer = null;
let idCounter = 0;

function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

function tick() {
  if (pieces.length === 0) { timer = null; return; }
  if (queue.length === 0) queue = shuffle(pieces);
  const next = queue.shift();
  if (listeners[next]) listeners[next]();
  timer = setTimeout(tick, 1600 + Math.random() * 800);
}

export function register(callback) {
  const id = `gp_${++idCounter}`;
  pieces.push(id);
  listeners[id] = callback;
  if (!timer) timer = setTimeout(tick, 1000 + Math.random() * 1000);
  return () => {
    pieces = pieces.filter(p => p !== id);
    queue = queue.filter(q => q !== id);
    delete listeners[id];
    if (pieces.length === 0 && timer) {
      clearTimeout(timer);
      timer = null;
    }
  };
}
